import client from './client';

const login = async (payload) => {
  const { data } = await client.post('/auth/login', payload);
  return data;
};

const register = async (payload) => {
  const { data } = await client.post('/auth/register', payload);
  return data;
};

export default {
  login,
  register,
};
